import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ConfigurationService from '../../../services/ConfigurationService';
import { translate } from '../../../utils/util';
import { validateInputsRequired, onValueChange } from '../../../utils/handleChangeHooks';
import { Breadcrumbs, Button, Input } from '../../../components/UI/ComponentsUI';
import { showMessageToastCustom } from '../../../utils/util';
import InputUI from '../../../components/UI/InputUI';

const TokenInsert = (props) => {
    const [token, setToken] = useState({});
    const [permissions, setPermission] = useState([]);

    const onChange = (event) => {
        onValueChange(event, token, setToken);
    }

    const onPermissionChange = (event) => {
        setPermission(event.target.value.split(','));
    }

    const onConfirm = () => {
        if (validateInputsRequired()) {
            var dataSend = { ...token, permissions };
            props.tokenPost(dataSend, (response) => {
                if (!response) {
                    showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                } else {
                    props.history.replace('./list');
                }
            });
        }
    };

    const titleToken = { icon: "mdi mdi-clipboard-check-outline", label: translate('menu.configuration', 'configuration') };
    const subtitlesToken = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-token", label: translate('menu.token', 'configuration') }];
        subtitlesItems = [...subtitlesItems, { label: translate('menu.insert', 'configuration') }];
        return subtitlesItems;
    }

    return (
        <div>
            <Breadcrumbs id="tokenInsert" title={titleToken} subtitles={subtitlesToken()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div className="row" style={{ marginBottom: '0px' }}>
                                <fieldset className='fieldset'>
                                    <legend style={{ padding: '0 5px' }}> Info</legend>
                                    <div className="input-field no-padding col s12">
                                        <Input required label={translate('token.name', 'configuration')} id="userName" name="userName" type="text" onChange={onChange} value={token?.userName} />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input required label={translate('token.userName', 'configuration')} id="name" name="name" type="text" onChange={onChange} value={token?.name} />
                                    </div>
                                    <div className='input-field no-padding col s12'>
                                        <Input label={translate('token.email', 'configuration')} id="email" name="email" type="text" onChange={onChange} value={token?.email} />
                                    </div>
                                    <div className='input-field no-padding col s12'>
                                        <InputUI label={translate('token.permissions', 'configuration')} id="permissions" name="permissions" type="text" onChange={onPermissionChange} value={token.permission} />
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <div className="card-action" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div className="row">
                                <div className="row" style={{ paddingTop: '10px' }}>
                                    <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                    <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = () => {
    return {
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        tokenPost: (token, callback) => {
            dispatch(ConfigurationService.addToken(token, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TokenInsert)));